import React from 'react';
import { FaWhatsapp } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
// import { FaTelegramPlane } from "react-icons/fa";


function Sidesocialmedia() {

    return (
        <div>
            <div style={{
                position: 'fixed',
                top: '40%',
                left: 10,
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                zIndex: 1000
            }} className='bg-white p-2 rounded-full shadow-lg shadow-red-400/50'>
                <div className='p-3 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://whatsapp.com/channel/0029VahVyMtDeON5Y7dKau3W ', '_blank')}>
                    <FaWhatsapp className="text-[#D8020D] text-5xl" />
                </div>
                <div className='p-3 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://www.instagram.com/swaminarayan_surat/', '_blank')}>
                    <FaInstagram className="text-[#D8020D] text-5xl" />
                </div>
                <div className='p-3 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://www.facebook.com/swaminarayansurat10', '_blank')}>
                    <FaFacebookSquare className="text-[#D8020D] text-5xl" />
                </div>
                {/* <div className='p-4 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://t.me/swaminarayansurat', '_blank')}>
                    <FaTelegramPlane className="text-[#D8020D] text-4xl" />
                </div> */}
                <div className='p-3 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://x.com/Smv_Surat', '_blank')}>
                    <FaXTwitter className="text-[#D8020D] text-5xl" />
                </div>
                <div className='p-3 bg-[#D8020D] bg-opacity-10 h-[40px] w-[40px] justify-center items-center flex rounded-full'
                    onClick={() => window.open('https://www.youtube.com/@Ladila_Ghanshyam', '_blank')}>
                    <FaYoutube className="text-[#D8020D] text-5xl" />
                </div>
            </div>
        </div>
    );
}

export default Sidesocialmedia;
